import { useTranslation } from "react-i18next";
import { CommissionContract } from "../../../api/ComissionContractsAPI";
import SectionTitle from "../../SectionTitle/SectionTitle";
import InputShortText from "../../InputShortText/InputShortText";
import PhoneNumberInput from "../../PhoneNumberInput/PhoneNumberInput";

interface BrideTabSectionProps {
  form: CommissionContract;
  commission: CommissionContract;
  isEditing: boolean;
  onInputChange: (field: keyof CommissionContract) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onPhoneChange: (value: string) => void;
}

export default function BrideTabSection({
  form,
  commission,
  isEditing,
  onInputChange,
  onPhoneChange,
}: BrideTabSectionProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <SectionTitle text={t("store_commission_panel.bride_data_title") || "Bride data"} />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-2">
        <InputShortText
          label={t("store_commission_panel.first_name") || "First name"}
          defaultValue={isEditing ? form.brideName : commission.brideName}
          onChange={isEditing ? onInputChange("brideName") : () => {}}
          isDisabled={!isEditing}
        />
        <InputShortText
          label={t("store_commission_panel.last_name") || "Last name"}
          defaultValue={isEditing ? form.brideSurname : commission.brideSurname}
          onChange={isEditing ? onInputChange("brideSurname") : () => {}}
          isDisabled={!isEditing}
        />
      </div>
      <div className="mb-2">
        {isEditing ? (
          <PhoneNumberInput
            label={t("store_commission_panel.phone") || "Phone"}
            defaultValue={form.bridePhone}
            onChange={onPhoneChange}
            isDisabled={false}
          />
        ) : (
          <InputShortText
            label={t("store_commission_panel.phone") || "Phone"}
            defaultValue={commission.bridePhone || ""}
            onChange={() => {}}
            isDisabled
          />
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-2">
        <InputShortText
          label={t("store_commission_panel.email") || "Email"}
          defaultValue={isEditing ? form.brideEmail : commission.brideEmail || ""}
          onChange={isEditing ? onInputChange("brideEmail") : () => {}}
          isDisabled={!isEditing}
        />
        <InputShortText
          label={t("store_commission_panel.social_media") || "Social media"}
          defaultValue={isEditing ? form.brideSocial : commission.brideSocial || ""}
          onChange={isEditing ? onInputChange("brideSocial") : () => {}}
          isDisabled={!isEditing}
        />
      </div>
    </div>
  );
}
